/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import faker from 'faker';
import { Factory } from 'miragejs';

const parentAccount = Factory.extend({
  id: () => faker.datatype.uuid(),
  name: () => `${faker.name.firstName()} ${faker.name.lastName()}`,
});

export default parentAccount;
